import { AppInfo, DevicePlatform } from "@/shared/types";

export const browserInfo = (): AppInfo => {
  /**
   * https://stackoverflow.com/questions/5916900/how-can-you-detect-the-version-of-a-browser
   */
  const ua = window.navigator.userAgent;
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  if (/trident/i.test(M[1])) {
    const tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { platform: DevicePlatform.Browser, name: "IE", version: tem[1] || "", isMobile: false };
  }

  if (M[1] === "Chrome") {
    const tem = ua.match(/\b(OPR|Edg)\/(\d+)/i);
    if (tem) {
      return {
        platform: DevicePlatform.Browser,
        name: tem[1].replace("OPR", "Opera").replace("Edg", "Edge"),
        version: tem[2],
        isMobile: false
      };
    }
  }

  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];

  const tem = ua.match(/version\/(\d+)/i);
  if (tem) {
    M.splice(1, 1, tem[1]);
  }

  return { platform: DevicePlatform.Browser, name: M[0], version: M[1], isMobile: false };
};
